import React, { useEffect, useState } from "react";
import cx from "classnames";
import styles from "./Pagination.module.css";
import uuid from "react-uuid";
import dynamic from "next/dynamic";
import { Skeleton } from "@mui/material";
const ReactPaginate = dynamic(() => import("react-paginate"), {
  ssr: false,
});

const Pagination = ({
  totalPage,
  activePage = 1,
  setActivePage,
  loading,
}) => {

  useEffect(() => {
    setActivePage(activePage);
  }, [activePage , setActivePage]);

  const activepageHandler = (n) => {
    setActivePage(n.selected + 1);
  };



  return (
    <div
      className={cx(
        styles.container,
        "d-flex",
        "align-items-center",
        "justify-content-center",
        "position-relative"
      )}
    >
      {loading ? (
        <div
          className={cx(
            styles.overlay,
            "d-flex",
            "w-100",
            "position-absolute",
            "align-items-center",
            "justify-content-evenly"
          )}
        >
          <Skeleton
            className={cx(styles.skeletonStyles)}
            variant="rectangular"
            height={30}
            width={30}
          />
          <Skeleton
            className={cx(styles.skeletonStyles)}
            variant="rectangular"
            height={30}
            width={30}
          />
          <Skeleton
            className={cx(styles.skeletonStyles)}
            variant="rectangular"
            height={30}
            width={30}
          />
          <Skeleton
            className={cx(styles.skeletonStyles)}
            variant="rectangular"
            height={30}
            width={30}
          />
        </div>
      ) : (
        <ReactPaginate
          forcePage={activePage && activePage < totalPage ? activePage - 1 : activePage===totalPage? activePage - 1  :0}
          key={uuid()}
          onPageChange={activepageHandler}
          className={cx(
            styles.paginationWrapper,
            "d-flex",
            "align-items-center",
            "justify-content-between",
            "p-0",
            "w-100",
            "h-100"
          )}
          pageCount={totalPage}
          activeClassName={cx(
            styles.page,
            styles.activePage,
            "d-flex",
            "align-items-center",
            "justify-content-center"
          )}
          nextClassName="d-none"
          previousClassName="d-none"
          pageClassName={cx(
            styles.page,
            "d-flex",
            "align-items-center",
            "justify-content-center"
          )}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
        />
      )}
    </div>
  );
};

export default Pagination;
